(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerShare',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.lp-share-type > .btn-default').click(function _shareTypePressed() {

			$('.lp-share-option').each(function _hideAll() {
				$(this).addClass('hidden');
			});

			switch ($(this).prop('innerText')) {
				case 'Link':
					clearLinkSections();
					clearVideoSections();

					$('#liveplannershare-link').val('');
					$('#liveplannershare-video').val('');
					$('.lp-share-link').removeClass('hidden');
					break;
				case 'Image':
					clearLinkSections();
					clearVideoSections();

					$('#liveplannershare-link').val('');
					$('#liveplannershare-video').val('');
					$('.lp-share-image').removeClass('hidden');
					$('.lp-share-comments').removeClass('hidden');
					break;
				case 'Embedded Video':
					clearLinkSections();
					clearVideoSections();

					$('#liveplannershare-link').val('');
					$('#liveplannershare-video').val('');
					$('.lp-share-video').removeClass('hidden');
					$('.lp-share-comments').removeClass('hidden');
					break;
				case 'File':
					clearLinkSections();
					clearVideoSections();

					$('#liveplannershare-link').val('');
					$('#liveplannershare-video').val('');
					$('.lp-share-file').removeClass('hidden');
					$('.lp-share-comments').removeClass('hidden');
					break;
				default:
					console.log("shouldnt be here");
					break;
			}
		});

		$('.lp-library-search').click(function _searchLibrary() {
			var term = $('#lp-search-term').val(),
				title,
				supplier,
				comment;

			if (term.length > 2) {
				$('.lp-library-items').each(function _hideItems() {
					$(this).addClass('hidden');
				});

				$('.lp-library-items').each(function _showItems() {
					title    = $(this).data('title').toLowerCase();
					supplier = $(this).data('supplier').toLowerCase();
					comment  = $(this).data('comment').toLowerCase();

					if (title.indexOf(term) >= 0 || supplier.indexOf(term) >= 0 || comment.indexOf(term) >= 0) {
						$(this).removeClass('hidden');
					}
				});

				$('.lp-library-clear').removeClass('hidden');
			} else {
				Adzuki.StatusMessage('Error', 'Search term is not long enough.');
			}
		});

		$('.lp-library-clear').click(function _clearSearch(e) {
			e.preventDefault();

			$('#lp-search-term').val('');
			$('.lp-library-items').each(function _unHideItems() {
				$(this).removeClass('hidden');
			});

			$(this).addClass('hidden');
		});

		$('#lp-search-term').keypress(function _executeSearch(e) {
			var keycode = (e.keyCode ? e.keyCode : e.which);

			if (keycode === 13) {
				$('.lp-library-search').trigger("click");
			}
		});

		Adzuki.Typeahead(
			$('#liveplannershare-link'),
			function getImages(term, display, $self) {
				let postData= {
					url: term
				};

				clearLinkSections();
				Adzuki.Ajax.post('/LivePlanner/embedlyImages', postData).then(function resolve(response) {
					$self.removeClass('ajax-spinner');
					let htmlContent = '<div class="alert alert-info">';
					if (response.success) {
						if (response.imageCount <= 0) {
							htmlContent = htmlContent
								+ 'We are unable to load images for the item provided. Therefore, no image will be tied to the item once shared with your client.';
						} else if (response.imageCount === 1) {
							htmlContent = htmlContent
								+ 'We have detected only one potential image for this item. Therefore, that image will be tied to the item once shared with your client.';
						} else {
							htmlContent = htmlContent
								+ 'We have detected multiple potential images for this item. The image shown below is currently tied to this item. If you would like to change this image, click <a href="#" class="visual-list" data-controller="LivePlanner" data-action="viewEmbedlyImages" data-select-box="liveplannershare-embedly_image"><b>here</b></a>\n'
								+ 'to see image options.';

							$('#liveplannershare-embedly_image').val(response.defaultImage);
							$('#liveplannershare-embedly_image').trigger('change');

							$('#embedly-link-image #selected-image').attr('src', response.defaultImage);
							$('#embedly-link-image').removeClass('hidden');
						}
					}
					htmlContent += '</div>';

					$('#embedly-image-section').removeClass('hidden');
					$('#embedly-image-section__text').html(htmlContent);

					initVisualList($('#embedly-image-section .visual-list'), term);
				});
			},
			function select(item, $self, typeahead) {
				return;
			}
		);

		Adzuki.Typeahead(
			$('#liveplannershare-video'),
			function getImages(term, display, $self) {
				let postData= {
					url: term
				};

				clearVideoSections();
				Adzuki.Ajax.post('/LivePlanner/embedlyImages', postData).then(function resolve(response) {
					$self.removeClass('ajax-spinner');
					let htmlContent = '<div class="alert alert-info">';
					if (response.success) {
						if (response.imageCount <= 0) {
							htmlContent = htmlContent
								+ 'We are unable to load images for the item provided. Therefore, no image will be tied to the item once shared with your client.';
						} else if (response.imageCount === 1) {
							htmlContent = htmlContent
								+ 'We have detected only one potential image for this item. Therefore, that image will be tied to the item once shared with your client.';
						} else {
							htmlContent = htmlContent
								+ 'We have detected multiple potential images for this item. The image shown below is currently tied to this item. If you would like to change this image, click <a href="#" class="visual-list" data-controller="LivePlanner" data-action="viewEmbedlyImages" data-select-box="liveplannershare-embedly_image"><b>here</b></a>\n'
								+ 'to see image options.';

							$('#liveplannershare-embedly_image').val(response.defaultImage);
							$('#liveplannershare-embedly_image').trigger('change');

							$('#embedly-link-image #selected-image').attr('src', response.defaultImage);
							$('#embedly-link-image').removeClass('hidden');
						}
					}
					htmlContent += '</div>';

					$('#embedly-video-section').removeClass('hidden');
					$('#embedly-video-section__text').html(htmlContent);

					initVisualList($('#embedly-video-section .visual-list'), term);
				});
			},
			function select(item, $self, typeahead) {
				return;
			}
		);

		/**
		 * Clear embedly link tab image sections
		 */
		function clearLinkSections() {
			$('#liveplannershare-embedly_image').val('');

			$('#embedly-image-section').addClass('hidden');
			$('#embedly-image-section__text').html('');

			$('#embedly-link-image').addClass('hidden');
			$('#embedly-link-imag #selected-image').attr('src', '');
		}

		/**
		 * Clear embedly video tab image sections
		 */
		function clearVideoSections() {
			$('#liveplannershare-embedly_image').val('');

			$('#embedly-video-section').addClass('hidden');
			$('#embedly-video-section__text').html('');

			$('#embedly-link-image').addClass('hidden');
			$('#embedly-link-imag #selected-image').attr('src', '');
		}
	};

	form.success = function success(response)
	{
		if (!Adzuki.Form.hasError(response)) {
			if ($('#liveplannershare-from_library').length > 0 && $('#liveplannershare-from_library').val() === '1') {
				document.location = Adzuki.base_uri + '/LivePlanner/library';
			} else {
				$('.modal').modal('hide');

				toastr.success(
					null,
					'Custom Item Sent',
					{
						positionClass  : 'toast-top-center',
						timeOut        : 3000,
						extendedTimeOut: 0,
					}
				);
			}
		}

		return false;
	};

	function initVisualList($visualListElement, url) {
		$visualListElement.click(function visualListClicked(e) {
			e.preventDefault();

			let $self              = $(this),
				controller         = $self.data('controller'),
				action             = $self.data('action'),
				select_box         = $self.data('select-box'),
				$modal             = $('#modal-share-form'),
				currently_selected = $('#' + select_box).val();

			let postData = {
				url       : url,
				select_box: select_box
			};

			Adzuki.Ajax.post('/' + controller + '/' + action, postData).then(function success(response) {
				$modal.addClass('wide');
				$modal.find('.modal-title').text("Visual List");
				$modal.find('.modal-body').html(response);

				$('.visual-list-item').each(function highlightBasedOnSelect() {
					if (parseInt($(this).data("id")) === parseInt(currently_selected)) {
						$(this).addClass("active");
					}
				});

				if ($('#liveplannershare-lp_session').val() === '1') {
					$('#modalWindow').modal('hide');
				}
				$modal.modal('show');
			});
		});

		$('#modal-share-form').on('click', '.visual-list-container .select-image', function selectImage(e) {
			let select_box_id = $(this).data("select"),
				src           = $(this).data("src");

			e.preventDefault();

			$('.visual-list > .active').each(function removeActive() {
				$(this).removeClass('active');
			});

			$(this).parents('.visual-list-item').addClass('active');

			if (src) {
				$('#visual_list_preview').attr('src', src);
				$('#visual_list_preview').removeClass('hidden');
			}

			$('#' + select_box_id).val(src);
			$('#' + select_box_id).trigger('change');

			$('#embedly-link-image #selected-image').attr('src', src);
			$('#embedly-link-image').removeClass('hidden');

			$('#modal-share-form').modal('hide');
			if ($('#liveplannershare-lp_session').val() === '1') {
				$('#modalWindow').modal('show');
			}
		});
	}
}(jQuery, window.Adzuki || {}));